import {
  UseInfiniteQueryOptions,
  useInfiniteQuery,
} from '@tanstack/react-query'

import {
  ChatParticipantList,
  QueryChatParticipantsArgs,
  QueryChatParticipantsByCursorArgs,
} from '@tribeplatform/gql-client/types'

import { useTribeClient } from '../../useTribeClient.js'
import { getChatParticipantsKey } from '../../utils/keys/messaging.key.js'

const isCursorQuery = (
  params: QueryChatParticipantsByCursorArgs | QueryChatParticipantsArgs,
): params is QueryChatParticipantsByCursorArgs => {
  return params && 'cursor' in params
}
export const useChatParticipants = (options: {
  variables: QueryChatParticipantsArgs
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<ChatParticipantList>
}) => {
  const { variables, useInfiniteQueryOptions } = options

  const { client } = useTribeClient()
  const chatParticipantsKey = getChatParticipantsKey({ variables })

  return useInfiniteQuery(
    chatParticipantsKey,
    async ({
      pageParam: params,
    }: {
      pageParam?: QueryChatParticipantsByCursorArgs | QueryChatParticipantsArgs
    }) => {
      if (isCursorQuery(params)) {
        return client.messaging.chatParticipantsByCursor(params)
      }
      return client.messaging.chatParticipants({
        ...variables,
      })
    },
    {
      ...(useInfiniteQueryOptions ?? {}),
      getNextPageParam: (
        lastPage,
        _pages,
      ): QueryChatParticipantsByCursorArgs | undefined => {
        if (lastPage.pageInfo?.endCursor) {
          return {
            cursor: lastPage.pageInfo.endCursor,
            limit: variables.limit,
            chatId: variables.chatId,
          }
        }

        return undefined
      },
    },
  )
}
